import React, { useContext, useState } from "react";
import Card from "../../../Card";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid2";
import MUIEditIcon from "@mui/icons-material/Edit";
import MUIIconButton from "@mui/material/IconButton";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import TileTerm from "../../../Tile/TileTerm";
import DialogSearchTerm from "../../../Dialog/Search/DialogSearchTerm";
import MainContext from "../../../../Context/MainContext/MainContext";

export default function CardAdminWidgetGeneral(props) {
  const context = useContext(MainContext);
  const [componentDialogOpen, setComponentDialogOpen] = useState(false);

  const selectedComponent = props.widget?.widgetComponentTermId
    ? context.termsIndexed[props.widget.widgetComponentTermId]
    : null;

  const handleEditComponent = () => {
    setComponentDialogOpen(true);
  };

  const handleClearComponent = () => {
    props.onChange({ widgetComponentTermId: null });
  };

  const componentIconButtons = [
    <MUIIconButton key="edit-component" onClick={handleEditComponent}>
      <MUIEditIcon />
    </MUIIconButton>,
  ];

  if (selectedComponent) {
    componentIconButtons.push(
      <MUIIconButton key="clear-component" onClick={handleClearComponent}>
        <MUIDeleteIcon />
      </MUIIconButton>,
    );
  }

  const renderContent = () => {
    return (
      <>
        <MUIGrid container spacing={2}>
          <MUIGrid
            size={{
              xs: 12,
              sm: 6,
              md: 4,
            }}
          >
            <MUITextField
              value={props.widget?.name ?? ""}
              autoFocus={true}
              size="small"
              label="Name"
              variant="standard"
              fullWidth={true}
              onBlur={(e) => props.onChange({ name: e.target.value.trim() })}
              onChange={(e) => props.onChange({ name: e.target.value })}
              required={true}
              error={props.validationIssues.name ? true : false}
              helperText={
                props.validationIssues.name ? props.validationIssues.name : ""
              }
              slotProps={{
                htmlInput: {
                  maxLength: 255,
                },

                inputLabel: { shrink: true },
              }}
            />
          </MUIGrid>
          <MUIGrid
            size={{
              xs: 12,
              sm: 6,
              md: 8,
            }}
          >
            <MUITextField
              value={props.widget?.description ?? ""}
              size="small"
              label="Description"
              variant="standard"
              fullWidth={true}
              onBlur={(e) =>
                props.onChange({ description: e.target.value.trim() })
              }
              onChange={(e) => props.onChange({ description: e.target.value })}
              required={false}
              error={props.validationIssues.description ? true : false}
              helperText={
                props.validationIssues.description
                  ? props.validationIssues.description
                  : ""
              }
              slotProps={{
                htmlInput: {
                  maxLength: 1024,
                },

                inputLabel: { shrink: true },
              }}
            />
          </MUIGrid>
          <MUIGrid
            size={{
              xs: 12,
              sm: 6,
              md: 4,
            }}
          >
            <TileTerm
              term={selectedComponent}
              iconButtons={componentIconButtons}
              label="Component"
              required={true}
              error={
                props.validationIssues.widgetComponentTermId ? true : false
              }
              helperText={
                props.validationIssues.widgetComponentTermId
                  ? props.validationIssues.widgetComponentTermId
                  : ""
              }
            />
          </MUIGrid>
        </MUIGrid>
        <DialogSearchTerm
          data={Object.values(context.termsIndexed).filter(
            (term) =>
              term.type === "dashboard_widget_component" &&
              term.deleted === false,
          )}
          open={componentDialogOpen}
          onClose={() => setComponentDialogOpen(false)}
          onSelect={(term) => {
            props.onChange({ widgetComponentTermId: term.id });
            setComponentDialogOpen(false);
          }}
        />
      </>
    );
  };

  return <Card renderContent={renderContent} getTitle={() => "General"} />;
}
